import Vue from 'vue'

class VehicleRepository {

    controller = {}

    search(data, instanceId = 'default') {
        return new Promise((resolve, reject) => {
            if(this.controller[instanceId]) {
                this.controller[instanceId].abort()
            }
            this.controller[instanceId] = new AbortController()

            Vue.auth.fetch({
                url: '/api/vehicles/search',
                method: 'post',
                data,
                signal: this.controller[instanceId].signal,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    exportCsv(data) {
        return new Promise((resolve, reject) => {
            Vue.auth.download({
                url: '/api/vehicles/export-csv',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    get(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id,
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    hub(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/hub',
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    create(data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    update(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id,
                method: 'put',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id,
                method: 'delete',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    archive(id, data = {}) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/archive',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    unarchive(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/unarchive',
                method: 'post',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    assignCustomer(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/assign-customer',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    unassignCustomer(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/unassign-customer',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    assignOrganization(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/assign-organization',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    unassignOrganization(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/unassign-organization',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    assignmentHistory(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/assignment-history',
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    readings(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/readings',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    suspectedMissingCharges(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/suspected-missing-charges',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    brands() {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/brands',
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    models(brand) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/models?' + new URLSearchParams({ brand }).toString(),
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    versions(brand, model) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/versions?' + new URLSearchParams({ brand, model }).toString(),
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    lookup(registrationNumber) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/lookup?' + new URLSearchParams({ registrationNumber }).toString(),
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    transfer(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/transfer',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    connectTelematics(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics/connect',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    disconnectTelematics(id, provider = null) {
        // Build the provider into the URL — Vue.auth.fetch does NOT forward `params` on a DELETE, which would
        // drop the ?provider and make the backend disconnect the DEFAULT connection instead of the chosen one.
        const qs = provider ? '?provider=' + encodeURIComponent(provider) : ''
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics/connect' + qs,
                method: 'delete',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // Create a PENDING consent carrying the config (mode/type/locationId) and email its public link (returns
    // the link too). Nothing else is created at this point — the licence/meter are materialised at consent.
    requestTelematicsConsent(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics/request-consent',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // Multi-connection (gated ZEborne operator): add a VIN provider (Volteras/LBC) directly, keeping the vehicle's
    // other connections. OAuth providers go through the consent link instead.
    connectProviderDirect(id, provider) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics/connect-provider',
                method: 'post',
                data: { provider },
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // Ask the org's fleet provider whether a VIN is eligible before declaring the vehicle.
    // Returns { eligible, hasPosition, comment } (fields null when no provider can answer).
    checkVinEligibility(vin, type = 'vin') {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/telematics/check-vin',
                method: 'post',
                data: { vin, type },
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // The connected-vehicle meter attached to this vehicle (reimbursement mode), or { meter: null }.
    getConnectedVehicleMeter(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/connected-vehicle-meter',
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // The connected-vehicle formulas the vehicle's organization offers (drives the wizard's toggles).
    getConnectableFormulas(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics/formulas',
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // Enable a connection by registering the matching licence (type oauth/vin + meter on/off).
    enableTelematicsConnection(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics/enable-connection',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // Re-email the existing pending consent link (no config needed — used from the fleet list).
    resendTelematicsConsent(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics/resend-consent',
                method: 'post',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // Fully remove the connection: terminate licence(s) + revoke consent + disconnect.
    terminateTelematicsConnection(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics/terminate',
                method: 'post',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // Provision the connected-vehicle home meter at the operator-chosen location (existing or created).
    provisionTelematicsMeter(id, data) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics/provision-meter',
                method: 'post',
                data,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // Public (tokenised, no login) — read the consent page context.
    getTelematicsConsent(token) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/auth/tokens/telematics-consent/get',
                method: 'post',
                data: { token },
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // Public (tokenised, no login) — the vehicle step's OAuth provider authorisation URL for the consent.
    telematicsConsentOAuthUrl(token, make = null) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/auth/tokens/telematics-consent/oauth-url',
                method: 'post',
                data: { token, make },
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // Public (tokenised, no login) — the OAuth provider returns to the consent page; it posts the code here to
    // exchange + capture the tokens on the consent. Returns { captured } or { selectVehicle, vehicles, sessionContext }.
    // payload = { code, state } (SmartCar) OR { token } (Enode — no code, the server queries the linked user).
    telematicsConsentOAuthCallback(payload) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/auth/tokens/telematics-consent/oauth-callback',
                method: 'post',
                data: payload,
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // Public (tokenised, no login) — multi-vehicle account: capture the vehicle the user picked. Only the consent
    // token + the chosen id travel; the server re-fetches the authoritative list before disconnecting the rest.
    telematicsConsentOAuthSelect(token, externalVehicleId) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/auth/tokens/telematics-consent/oauth-callback/select',
                method: 'post',
                data: { token, externalVehicleId },
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    // Public (tokenised, no login) — grant the consent, optionally uploading the electricity bill.
    grantTelematicsConsent(payload, bill = null) {
        return new Promise((resolve, reject) => {
            const formData = new FormData()
            formData.append('data', JSON.stringify(payload))
            if (bill) {
                formData.append('electricityBill', bill)
            }
            Vue.auth.fetch({
                url: '/api/auth/tokens/telematics-consent/grant',
                method: 'post',
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' },
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    telematics(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics',
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    telematicsSignals(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics/signals',
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    registerTelematics(id, provider = null) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics/register',
                method: 'post',
                data: provider ? { provider } : {},
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    connectedVehicleMeterLicence(id) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/connected-vehicle-meter-licence',
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    telematicsRefresh(id, provider = null) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/' + id + '/telematics/signals/refresh',
                method: 'post',
                data: provider ? { provider } : {},
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    getVersion(versionId) {
        return new Promise((resolve, reject) => {
            Vue.auth.fetch({
                url: '/api/vehicles/versions/' + versionId,
                method: 'get',
            }).then(response => {
                resolve(response.data)
            }).catch(err => {
                reject(err)
            })
        })
    }
}

export default new VehicleRepository()
